import {
  Component,
  ComponentFactoryResolver, ComponentRef,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  ViewChild
} from "@angular/core";
import {Subject} from "rxjs";
import {Set} from "../../../../model/set.model";
import {IFieldConfig, ListerComponent} from "../../../generics/lister/lister.component";
import {DynamicHostDirective} from "../../../../directives/dynamic-host.directive";
import {ListGetterService} from "../../../../services/generic/list-getter.service";
import {LibSetService} from "../../../../services/entities/lib-set/lib-set.service";

@Component({
  selector: 'app-list-lib-set',
  templateUrl: './list-lib-set.component.html',
  styleUrls: ['./list-lib-set.component.scss']
})
export class ListLibSetComponent implements OnInit {

  @Input()
  hookEvents: Subject<string>;

  @Input()
  actions: String[];

  // =============================== OUTPUTS
  @Output()
  select: EventEmitter<Set> = new EventEmitter();

  @Output()
  delete: EventEmitter<Set> = new EventEmitter();

  @Output()
  create: EventEmitter<Set> = new EventEmitter();

  @Output()
  import: EventEmitter<Boolean> = new EventEmitter();

  component: any;
  fields: IFieldConfig[] = [
    {
      key: "label",
      i18Key: "set.label",
      width: 30,
      searchable: true
    },
    {
      key: "comment",
      i18Key: "set.comment",
      width: 55,
      searchable: true,
    },
    {
      key: "price",
      i18Key: "common.price",
      width: 15,
      searchable: false,
      serviceFunctionName: 'getOneElementPrice'
    },
  ];

  @ViewChild(DynamicHostDirective, {static: true}) dynamicHost: DynamicHostDirective;

  constructor(private factory: ComponentFactoryResolver,
              private libSetService: LibSetService,
              private injector: Injector
  ) {
    this.component = ListerComponent
  }

  ngOnInit(): void {
    let factory = this.factory.resolveComponentFactory(this.component);
    const ref: ComponentRef<any> = this.dynamicHost.viewContainerRef
      .createComponent(factory, undefined, Injector.create({
        providers: [
          {
            provide: ListGetterService,
            useValue: this.libSetService
          },
          {
            provide: "FIELD_CONFIG",
            useValue: this.fields
          }
        ],
        parent: this.injector
      }));
    ref.instance.actions = this.actions;
    ref.instance.queriables = ["set.label"];
    ref.instance.select = this.select;
    ref.instance.delete = this.delete;
    ref.instance.create = this.create;
    ref.instance.import = this.import;
    ref.instance.hookEvents = this.hookEvents;
  }

}
